import { TypePaginationParams, ControlRoomRequestingOrderSummary, } from '@types'

type ControlRoomRequestingState = {
  summary: ControlRoomRequestingOrderSummary | null
}

export const SET_CONTROL_ROOM_REQUESTING_ORDER_SUMMARY = 'reducers/controlRoomRequesting/SET_CONTROL_ROOM_REQUESTING_ORDER_SUMMARY' as const
export const GET_CONTROL_ROOM_REQUESTING_ORDER_SUMMARY = 'reducers/controlRoomRequesting/GET_CONTROL_ROOM_REQUESTING_ORDER_SUMMARY' as const
export const GET_UNASSIGNED_CONTROL_ROOM_REQUESTING_ORDERS = 'reducers/controlRoomRequesting/GET_UNASSIGNED_CONTROL_ROOM_REQUESTING_ORDERS' as const
export const GET_ACTIVE_CONTROL_ROOM_REQUESTING_ORDERS = 'reducers/controlRoomRequesting/GET_ACTIVE_CONTROL_ROOM_REQUESTING_ORDERS' as const

export const setControlRoomRequestingOrderSummary = (summary: ControlRoomRequestingOrderSummary) => ({
  type: SET_CONTROL_ROOM_REQUESTING_ORDER_SUMMARY,
  summary,
})

export const getControlRoomRequestingOrderSummary = () => ({
  type: GET_CONTROL_ROOM_REQUESTING_ORDER_SUMMARY,
})

export const getUnassignedControlRoomRequestingOrders = (pagination: TypePaginationParams) => ({
  type: GET_UNASSIGNED_CONTROL_ROOM_REQUESTING_ORDERS,
  pagination,
})

export const getActiveControlRoomRequestingOrders = (pagination: TypePaginationParams) => ({
  type: GET_ACTIVE_CONTROL_ROOM_REQUESTING_ORDERS,
  pagination,
})

type AppStateAction =
  | ReturnType<typeof setControlRoomRequestingOrderSummary>
  | { type: 'persist/REHYDRATE' }

const initialState: ControlRoomRequestingState = {
  summary: null,
}

const reducers = (state = initialState, action: AppStateAction) => {
  switch(action.type) {
    case SET_CONTROL_ROOM_REQUESTING_ORDER_SUMMARY:
      return Object.assign({}, state, {
        summary: action.summary,
      })
    default:
      return state
  }
}

export default reducers
